export default "__VITE_ASSET__4MN1uUGV__"